export class JobTitle {
    abbreviation: string;
    id: number;
    jobTitleAssignmentId: number;
    modifiedByUserName: string;
    modifiedDate: Date;    
    mostRecent: boolean;
    position: string;
    errorMessage:string;
    order: number;
}